const MapToastMessage = {
  LOAD_FAILURE: '지도를 불러오지 못했습니다.<br />다시 시도해 주세요.',
  NO_PARKING_INFO: '제공 가능한 주차 정보가 없습니다.<br />지도를 이동해 주세요.',
  ZOOM_TOO_WIDE: '보고 있는 지역이 넓습니다.<br />지도를 확대해 주세요.',
  NONE: ''
}

const AirportMarkers = [
  {
    key: 'ICN_T1', // 인천공항 제1터미널 마커
    position: {
      lat: 37.4493289,
      lng: 126.4508345
    }
  },
  {
    key: 'ICN_T2', // 인천공항 제2터미널 마커
    position: {
      lat: 37.4673632,
      lng: 126.4346652
    }
  },
  {
    key: 'GMP', // 김포공항 마커
    position: {
      lat: 37.5668999,
      lng: 126.8012509
    }
  }
]

export { MapToastMessage, AirportMarkers }
